import { TaskFull } from 'interfaces/task.interface';
import { RoleTaskFull, RoleTaskFullIds } from 'interfaces/roleTask.interface';
import { ShortUser } from '@umanforge/common';

export class TaskUserUtils {
  /**
   * Check if there are operator absences in the tasks
   */
  static hasOperatorAbsences( tasks: TaskFull[], allRoleTasks: Map<string, RoleTaskFull[]> ): boolean {
    return tasks.some( task => {
      const roleTasks = allRoleTasks.get( task.id ) || [];
      return roleTasks.some( roleTask => {
        return roleTask.users.length < roleTask.count;
      } );
    } );
  }

  /**
   * Filter tasks to only show those where the user is assigned
   */
  static filterTasksByUser( tasks: TaskFull[], userId: string, allRoleTasks: Map<string, RoleTaskFull[]> ): TaskFull[] {
    return tasks.filter( task => {
      const roleTasks = allRoleTasks.get( task.id ) || [];
      if ( Array.isArray( roleTasks ) ) {
        return roleTasks.some( roleTask => {
          return roleTask.users.some( user => {
            return user.id === userId;
          } );
        } );
      }
      return false;
    } );
  }

  /**
   * Filter tasks to only show those where the user is assigned
   */
  static filterTasksByUserWithRTIds( tasks: TaskFull[], userId: string, allRoleTasks: RoleTaskFullIds[] ): TaskFull[] {
    return tasks.filter( task => {
      const roleTasks = allRoleTasks.filter( rt => { return rt.idTask == task.id; } );
      if ( Array.isArray( roleTasks ) ) {
        return roleTasks.some( roleTask => {
          return roleTask.users.some( usId => {
            return usId === userId;
          } );
        } );
      }
      return false;
    } );
  }

  /**
   * Check if a user is assigned to a specific task
   */
  static isUserAssignedToTask( task: TaskFull, userId: string, allRoleTasks: Map<string, RoleTaskFull[]> ): boolean {
    const roleTasks = allRoleTasks.get( task.id ) || [];
    if ( Array.isArray( roleTasks ) ) {
      return roleTasks.some( roleTask => {
        return roleTask.users.some( user => {
          return user.id === userId;
        } );
      } );
    }
    return false;
  }


  /**
   * Check if a user is assigned to a specific task
   */
  static isUserAssignedToTaskWithRTIds( task: TaskFull, userId: string, allRoleTasks: RoleTaskFullIds[] ): boolean {
    const roleTasks = allRoleTasks.filter( rt => { return rt.idTask == task.id; } );
    if ( Array.isArray( roleTasks ) ) {
      return roleTasks.some( roleTask => {
        return roleTask.users.some( user => {
          return user === userId;
        } );
      } );
      return false;
    }
    return false;
  }

  /**
   * Get the users assigned to a task
   */
  static getTaskUsers( taskId: string, allRoleTasks: Map<string, RoleTaskFull[]> ): ShortUser[] {
    const roleTasks = allRoleTasks.get( taskId ) || [];
    if ( !Array.isArray( roleTasks ) ) {
      return [];
    }
    const users: ShortUser[] = [];

    roleTasks.forEach( roleTask => {
      if ( roleTask.users && roleTask.users.length > 0 ) {
        roleTask.users.forEach( user => {
          if ( !users.some( u => { return u.id == user.id; } ) ) {
            users.push( user );
          }
        } );
      }
    } );

    return users;
  }

  /**
   * Check if a specific task is missing operators
   */
  static isTaskMissingOperators( task: TaskFull, allRoleTasks: Map<string, RoleTaskFull[]> ): number {
    const roleTasks = allRoleTasks.get( task.id ) || [];
    let sum = 0;
    if ( !Array.isArray( roleTasks ) ) {
      return 0;
    }
    roleTasks.forEach( roleTask => {
      sum += ( roleTask.count - roleTask.users.length );
    } );
    return sum;
  }
}
